import React from "react";
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from "react-router-dom";
import RegistrationForm from "./RegistrationForm";
import AdminPanel from "./AdminPanel";
import Dashboard from "./Dashboard";
import "./Form.css";
import SchoolLogin from "./LoginPage";

function App() {
  const isAuthenticated = !!localStorage.getItem("token");

  return (
    <Router>
      <div>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <nav className="main-nav">
                  <Link to="/"></Link>
                </nav>
                <div className="container">
                  <RegistrationForm />
                </div>
              </>
            }
          />

          <Route path="/mvm-school-admin-part-tree-adminpanel" element={<AdminPanel />} />
          <Route path="/schoollogin" element={<SchoolLogin />} />
          <Route
            path="/dashboard"
            element={isAuthenticated ? <Dashboard /> : <Navigate to="/schoollogin" />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
